import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* LOGO */}
        <div className="footer-logo">Logo</div>

        {/* LINKOVI */}
        <div className="footer-links">
          <Link to="/">Politika privatnosti</Link>
          <Link to="/">Uvjeti korištenja</Link>
          <Link to="/">Kontakt</Link>
        </div>

        {/* IKONE */}
        <motion.div
          className="social-icons"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <a href="/" target="_blank" rel="noreferrer">
            <i className="fi fi-brands-instagram"></i>
          </a>
          <a href="/" target="_blank" rel="noreferrer">
            <i className="fi fi-brands-facebook"></i>
          </a>
        </motion.div>

        {/* COPYRIGHT */}
        <div className="footer-copyright">
          &copy; {currentYear} Yummy Grub. Sva prava pridržana.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
